import { createContext } from 'react';

export type FieldContextValue = {
  label?: React.ReactNode;
  helpText?: React.ReactNode;
  disabled?: boolean;
  error?: boolean;
  size?: 'small' | 'medium' | 'large';
};

export const FieldContext = createContext<FieldContextValue | null>(null);
